import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { RentalUnitType } from 'src/lib/fliko/models/units/unit.data';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { UsersResidentHistoryComponent } from '../components/common/users-resident-history/users-resident-history.component';
/* eslint-disable max-len */
import { UsersCommApartmentReportComponent } from '../components/community/users-comm-apartment-report/users-comm-apartment-report.component';
import { UsersPrsAgreementReportComponent } from '../components/prs/users-prs-agreement-report/users-prs-agreement-report.component';
import { UsersCommApartmentDetailsComponent } from '../panels/community/users-comm-apartment-details/users-comm-apartment-details.component';
import { UsersCommParkingStorageDetailsComponent } from '../panels/community/users-comm-parking-storage-details/users-comm-parking-storage-details.component';
import { UsersCommResidentDetailsComponent } from '../panels/community/users-comm-resident-details/users-comm-resident-details.component';
import { UsersPrsAgreementDetailsComponent } from '../panels/prs/users-prs-agreement-details/users-prs-agreement-details.component';
import { UsersPrsRentalUnitDetailsComponent } from '../panels/prs/users-prs-rental-unit-details/users-prs-rental-unit-details.component';
import { UsersPrsLandlordTenantDetailsComponent } from '../panels/prs/users-prs-landlord-tenant-details/users-prs-landlord-tenant-details.component';
/* eslint-enable max-len */
import { UserCommList, UserPRSList } from './models/users-table.data';
import { BulkAppInvitationsComponent } from '../dialogs/bulk-app-invitations/bulk-app-invitations.component';

@Injectable({
  providedIn: 'root'
})
export class UsersStateService {
  // community
  public landlordsListPage: BehaviorSubject<number> = new BehaviorSubject(0);
  public tenantsListPage: BehaviorSubject<number> = new BehaviorSubject(0);

  // common
  public appRequestsListPage: BehaviorSubject<number> = new BehaviorSubject(0);
  public requestsResidentsListPage: BehaviorSubject<number> = new BehaviorSubject(0);
  public rentalUnitsListPage: BehaviorSubject<number> = new BehaviorSubject(0);

  // prs
  public agreementsListPage: BehaviorSubject<number> = new BehaviorSubject(0);
  public landlordsTenantsListPage: BehaviorSubject<number> = new BehaviorSubject(0);

  private detailsConfig = { panelClass: 'unpadded-dialog' };
  private raportConfig = { autoSize: true };

  constructor(private dialogService: DialogService) {}

  public showCommUnitDetails(
    data: UserCommList.ApartmentElement | UserCommList.ParkingStorageElement,
    type: RentalUnitType,
    onLeft?: boolean
  ): void {
    if (!onLeft) this.dialogService.closeAllDialogs();
    const config = {
      ...this.detailsConfig,
      ...(onLeft ? { position: { left: '0' } } : {})
    };
    if (type == RentalUnitType.APARTMENT) {
      this.dialogService.openPanelDialog(UsersCommApartmentDetailsComponent, data, config);
    } else {
      this.dialogService.openPanelDialog(UsersCommParkingStorageDetailsComponent, data, config);
    }
  }

  public showCommResidentDetails(data: UserCommList.ResidentElement): void {
    this.dialogService.closeAllDialogs();
    this.dialogService.openPanelDialog(UsersCommResidentDetailsComponent, data, this.detailsConfig);
  }

  public showPrsAgreementDetails(data: UserPRSList.AgreementElement): void {
    this.dialogService.closeAllDialogs();
    this.dialogService.openPanelDialog(UsersPrsAgreementDetailsComponent, data, this.detailsConfig);
  }

  public showPrsUnitDetails(data: UserPRSList.RentalUnitElement, onLeft?: boolean): void {
    if (!onLeft) this.dialogService.closeAllDialogs();
    this.dialogService.openPanelDialog(UsersPrsRentalUnitDetailsComponent, data, {
      ...this.detailsConfig,
      ...(onLeft ? { position: { left: '0' } } : {})
    });
  }

  public showPRSResidentDetails(data: UserPRSList.ResidentElement): void {
    this.dialogService.closeAllDialogs();
    this.dialogService.openPanelDialog(UsersPrsLandlordTenantDetailsComponent, data, this.detailsConfig);
  }

  public showCommunityRaport(): void {
    this.dialogService.openSimpleDialog(UsersCommApartmentReportComponent, null, this.raportConfig);
  }

  public showPrsRaport(): void {
    this.dialogService.openSimpleDialog(UsersPrsAgreementReportComponent, null, this.raportConfig);
  }

  public showResidentHistory(residentId: string): void {
    this.dialogService.openSimpleDialog(UsersResidentHistoryComponent, residentId);
  }

  public showBulkInvitesDialog(): void {
    this.dialogService.openSimpleDialog(BulkAppInvitationsComponent, null);
  }
}
